<template>
  <el-form-item
    :label="label"
    class="cargo-passenger-type"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="cargoPassengerType"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <span style="float: left;">{{item.label}}</span>
        <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{item.value}}</span> -->
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '貨客区分'
    },
    prop: {
      type: String,
      default: 'cargo_passenger_type'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    cargoPassengerType: {
      get () {
        return this.value
      },
      set (cargoPassengerType) {
        this.$emit('change', cargoPassengerType)
        this.options = this.optionsOriginal
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const cargoPassengerType = await this.loadCode()
    const cargoPassengerTypeSet = cargoPassengerType.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = cargoPassengerTypeSet
    this.optionsOriginal = cargoPassengerTypeSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'AIRCRAFT_ATTRIBUTE' } })
          .then((res) => {
            sessionStorage.setItem('cargoPassengerType', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('cargoPassengerType'))
    }
  }
}
</script>

<style lang="scss" scoped>
.passenger-cargo-type {
  ::v-deep .el-form-item__content {
    width: 6em;
  }
}
</style>
